<div class="household-location-preferences-container">
  <div class="header-label">Location Preferences
    <span id="householdLocationPreferencesToolTipIcon"
      class="infoIcon" calltoaction
    [calltoactionTemplate]="householdLocationPreferencesToolTipTemplateRef"></span>
  </div>
  <ng-template #householdLocationPreferencesToolTipTemplateRef>
    <div>
      <p>The asset location <strong>level</strong> is a number assigned to each security that represents your relative preference
      for each security to be purchased in a tax advantaged account or a taxable account.
      +100 represents the highest tax impact and therefore greatest preference for tax advantaged account
      placement, while -100 is the greatest preference for taxable account placement. The <strong>Roth level</strong> is a
      number assigned to securities identifying a preference to be bought in a Roth account. Numbers may
      range from +100 to 0, with +100 representing greatest preference to locate into a Roth account relative
      to other securities with a lower <strong>Roth level</strong>.</p>
      <p>You can choose from:</p>
      <p style="margin-top:10px">During rebalancing, iRebal will place the securities with the highest <strong>Roth level</strong> into Roth accounts
      first. If no more security buys with a <strong>Roth level</strong> exist or no more buys to be made in Roth accounts,
      iRebal will locate based on level, placing the securities with the highest absolute value of location
      level into the desired accounts first, resulting in a greater chance of getting the securities ranked
    closer to -100 and +100 into the appropriate taxable or tax advantaged accounts.</p>
  </div>
</ng-template>

<div class="input-slider">
  <div class="d-flex prob-worth">
    <div class="col1 bold d-flex">
      <div>Level</div>
    </div>
    <div class="col2">
      <irb-number-text-box name="level"
        [(value)]="textLevelValue"
        [min]="levelMinValue"
        [max]="levelMaxValue"
        (valueChange)="handleTextLevelChange()"
        [places]="0"
        [disabled]="false"
        isRequired="true"
        [placeholder]="levelValuePlaceholder"
        width="60px"
        #textLevelValueInput>
      </irb-number-text-box>
    </div>
    <div class="col3">
      <p-slider name="levelSlider" [(ngModel)]="sliderLevelValue"
        [range]="false" [min]="levelMinValue" [max]="levelMaxValue" (onChange)="handleSliderLevelChange()">
      </p-slider>
      <div class="slider-mark-container">
        @for (i of arr(levelSliderNumber).fill(1); track i) {
          <div></div>
        }
      </div>
      <div class="slider-label-container">
        <div class="level-step-1">-100</div>
        <div class="level-step-2">0</div>
        <div class="level-step-3">+100</div>
      </div>
      <div class="slider-description-container">
        <div class="level-step-1-description">Less tax impact (Hold in taxable accounts)</div>
        <div class="level-step-2-description">Neutral</div>
        <div class="level-step-3-description">More tax impact (Hold in qualified accounts)</div>
      </div>
    </div>
  </div>
  <div class="d-flex dte">
    <div class="col1">
      <span class="bold">Roth Level </span>
    </div>
    <div class="col2">
      <irb-number-text-box name="rothLevel"
        [(value)]="textRothLevelValue"
        [min]="rothLevelMinValue"
        [max]="rothLevelMaxValue"
        (valueChange)="handleTextRothLevelChange()"
        [places]="0"
        isRequired="true"
        [placeholder]="rothLevelValuePlaceholder"
        width="60px"
        #textRothLevelValueInput>
      </irb-number-text-box>
    </div>
    <div class="col3">
      <p-slider name="rothLevelSlider" [(ngModel)]="sliderRothLevelValue"
        [range]="false" [min]="rothLevelMinValue" [max]="rothLevelMaxValue" (onChange)="handleSliderRothLevelChange()" >
      </p-slider>
      <div class="slider-mark-container">
        @for (i of arr(rothLevelSliderNumber).fill(1); track i) {
          <div></div>
        }
      </div>
      <div class="slider-label-container">
        <div class="step-1">0</div>
        <div class="step-2">50</div>
        <div class="step-3">+100</div>
      </div>
      <div class="slider-description-container">
        <div class="level-step-1-description">Less tax impact (Hold in taxable accounts)</div>
        <div class="level-step-2-description">Neutral</div>
        <div class="level-step-3-description">More tax impact (Hold in qualified accounts)</div>
      </div>
    </div>
  </div>
</div>

</div>
